<template>
  <div class="tab">
    <div class="tab-nav">
      <div v-for="(item, index) in tabNavList" @click.stop="handleTabNavClick(item, index)"
           :style="{'width': width+'px', 'height': item.name === activeName ? (height+ 10) + 'px' : height + 'px'}"
           :class="['tab-nav-item', item.name === activeName ? 'active' : '']" ref="tabNavItemRefs">
        <img v-show="item.name === activeName" src="@/assets/images/list/ang1.png" class="ang-1" alt=""/>
        <img v-show="item.name === activeName" src="@/assets/images/list/ang2.png" class="ang-2" alt=""/>
        <div class="cn-text" v-if="item.cnText">{{ item.cnText }}</div>
        <div class="en-text" v-if="item.enText">{{ item.enText }}</div>
      </div>
    </div>
    <div class="tab-content-wrap">
      <slot></slot>
      <img src="@/assets/images/list/ang3.png" class="ang-3" alt=""/>
      <img src="@/assets/images/list/ang4.png" class="ang-4" alt=""/>
      <img src="@/assets/images/list/ang2.png" class="ang-5" alt=""/>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
    },
    width: {
      type: Number,
      default: 200,
    },
    height: {
      type: Number,
      default: 68,
    },
  },
  components: {},
  data() {
    return {
      tabNavList: [],
      activeName: "",
      currentIndex: 0,
    };
  },
  mounted() {
    this.init();
    this.$store.commit('app/SET_MEDIATIONTABNAME', this.value);
  },
  methods: {
    init() {
      this.activeName = this.value;
      this.$nextTick(() => {
        this.currentIndex = this.$children.findIndex(
          (component) => component.name === this.value
        );
      });
    },
    setTabBar(tabsPaneInstance) {
      this.tabNavList.push({
        cnText: tabsPaneInstance.cnLabel,
        enText: tabsPaneInstance.enLabel,
        name: tabsPaneInstance.name,
      });
    },
    handleTabNavClick(item, index) {
      if (item.name === this.activeName) return;
      this.activeName = item.name;
      this.currentIndex = index;
      this.$store.commit('app/SET_MEDIATIONTABNAME', this.activeName);
    },
  },
};
</script>
<style lang="less">
.tab {
  .tab-nav {
    display: flex;
    position: relative;
    margin-top: 8px;

    .tab-nav-item {
      position: relative;
      margin-top: 10px;
      margin-right: 10px;
      border: 1px solid #0084ff;
      border-bottom: 0;
      background-image: linear-gradient(#0d2c60, #010345);
      flex-direction: column;
      cursor: pointer;
      text-align: center;
    }

    .tab-nav-item.active {
      margin-top: 0;
    }

    .tab-nav-item.active > .ang-1, .ang-2 {
      position: absolute;
      height: 50%;
      top: -1px;
    }

    .tab-nav-item.active > .ang-1 {
      left: -1px;
    }

    .tab-nav-item.active > .ang-2 {
      right: -1px;
    }

    .tab-nav-item > .cn-text {
      position: absolute;
      width: 100%;
      height: 26px;
      bottom: 50%;
      color: #b1e3ff;
      font-size: 20px;
    }

    .tab-nav-item > .en-text {
      position: absolute;
      width: 100%;
      height: 26px;
      top: 50%;
      color: rgba(177, 227, 255, .6);
      font-size: 13px;
    }

    .tab-nav-item.active > .cn-text {
      color: #0ebd35;
    }

    .tab-nav-item.active > .en-text {
      color: #0ebd35;
    }
  }

  .tab-content-wrap {
    position: relative;
    min-height: 200px;
    border: 1px solid #0084ff;
    background: rgba(15, 31, 70, .6);

    .ang-3, .ang-4, .ang-5 {
      position: absolute;
      width: 35px;
    }

    .ang-3 {
      bottom: -1px;
      left: -1px;
    }

    .ang-4 {
      bottom: -1px;
      right: -1px;
    }

    .ang-5 {
      top: -1px;
      right: -1px;
    }
  }
}
</style>
